'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullDescription = undefined;

var _FullDescription2 = require('./FullDescription');

var _FullDescription3 = _interopRequireDefault(_FullDescription2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FullDescription = _FullDescription3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/FullDescription/index.js
// module id = 1629
// module chunks = 0